/**
 * Konvertiert die Nummernrepräsentation (Millisekunden) eines Datums in ein Date-Objekt
 * Benötigt z.B. im Rahmen von REST-Ergebnissen
 */
export function millisToDate( obj: any ): any {
    if ( obj && !( obj instanceof Date ) ) {
        return new Date( Number.parseInt( obj.toString(), 10 ) );
    }
    return obj;
}